exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".media-content[data-v-518763f9] {\n  height: 156px;\n  width: 232px;\n  border-radius: 12px;\n  background-position: center center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  overflow: hidden;\n}\n.image[data-v-518763f9],\n.video[data-v-518763f9] {\n  cursor: pointer;\n}\n.video[data-v-518763f9] {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.video:hover .play[data-v-518763f9] {\n    opacity: 0.8;\n}\n.play[data-v-518763f9] {\n  color: #dadada;\n  opacity: 0.6;\n  font-size: 48px;\n  transition: opacity 1s ease;\n}\n", ""]);

// exports
